<template>
    <div id="tradePage">
        <div class="trade-left" :style="{'height': tableHeight}">
            <div class="trade-li"
                 @click="setThisTab(index)"
                 :class="{'on': +tabId === index}"
                 v-for="(tab, index) in leftTab"
                 v-loading="!lenSta[index]"
                 element-loading-spinner="el-icon-loading"
                 element-loading-background="rgba(0, 0, 0, 0.2)"
                 :key="tab">
                <div class="img" :class="'ic' + (index + 1)"></div>
                <div class="txt">{{tab}}</div>
            </div>
        </div>
        <div class="trade-right-box" :style="{'height': tableHeight}">
            <gp-list v-if="dpDataList && lenSta[+tabId]"
                     :tags="dptag"
                     :types="1"
                     :tabId="+tabId"
                     :remains="trLines()"
                     :showIng="+tabId === 0"
                     :class="{'show': +tabId === 0}"
                     :style="{'height': tableHeight}"
                     :dataList="dpDataList"></gp-list>
            <template v-if="gupiaolist_sz">
                <gp-list v-if="gpDataList && lenSta[+tabId]"
                         :tags="gptags"
                         :types="2"
                         :tabId="+tabId"
                         :remains="trLines()"
                         :showIng="+tabId === 1"
                         :class="{'show': +tabId === 1}"
                         :style="{'height': tableHeight}"
                         :codes="gpDataList"></gp-list>

                <gp-list v-if="zxDataList && lenSta[+tabId]"
                         :tags="gptags"
                         :types="2"
                         :tabId="+tabId"
                         :remains="trLines()"
                         :showIng="+tabId === 2"
                         :class="{'show': +tabId === 2}"
                         :style="{'height': tableHeight}"
                         :codes="zxDataList"></gp-list>

                <gp-list v-if="cyDataList && lenSta[+tabId]"
                         :tags="gptags"
                         :types="2"
                         :tabId="+tabId"
                         :remains="trLines()"
                         :showIng="+tabId === 3"
                         :class="{'show': +tabId === 3}"
                         :style="{'height': tableHeight}"
                         :codes="cyDataList"></gp-list>

                <gp-list v-if="kcDataList && lenSta[+tabId]"
                         :tags="gptags"
                         :types="2"
                         :tabId="+tabId"
                         :remains="trLines()"
                         :showIng="+tabId === 4"
                         :class="{'show': +tabId === 4}"
                         :style="{'height': tableHeight}"
                         :codes="kcDataList"></gp-list>

                <gp-list v-if="ziDataList && lenSta[+tabId]"
                         :tags="gptags"
                         :types="2"
                         :tabId="+tabId"
                         :remains="trLines()"
                         :showIng="+tabId === 5"
                         :class="{'show': +tabId === 5}"
                         :style="{'height': tableHeight}"
                         :codes="ziDataList"></gp-list>
            </template>
        </div>
    </div>
</template>

<script>
    import GetGpList from './TradePageGpListGet'
    import TradePageGpList from './TradePageGpList'

    export default {
        name: "tradePage",
        components: {'gp-list': TradePageGpList},
        data: function () {
            return {
                leftTab: Object.freeze(this.$globle.bkTags),
                tabId: 0,
                dptag: Object.freeze(this.$globle.dpanHeads),
                gptags: Object.freeze(this.$globle.TradeHeads),
                tableHeight: window.innerHeight - (this.$store.state.hideFooter ? 76 : 401) + 'px'
            }
        },
        created() {
            this.tabId = this.$route.params.id;
        },
        computed: {
            /**
             * 即使计算当前股票列表窗口高度
             * @returns {string}
             */
            // 获取板块股票列表
            ...GetGpList,
            // 左侧菜单加载状态，如果没有数据，点不开的
            lenSta() {
                const dpLen = this.dpDataList && this.dpDataList.length;
                const pgLen = this.gpDataList && this.gpDataList.length;
                const zxLen = this.zxDataList && this.zxDataList.length;
                const cyLen = this.cyDataList && this.cyDataList.length;
                const kcLen = this.kcDataList && this.kcDataList.length;
                const ziLen = this.ziDataList && this.ziDataList.length;
                return [dpLen, pgLen, zxLen, cyLen, kcLen, ziLen];
            },
            // 返回深证股票的详情，没有是不会加载列表的
            gupiaolist_sz() {
                try {
                    return this.$store.state.gupiaolist_sz.entities.patrons
                } catch (e) {
                    return null;
                }
            }
        },
        mounted() {
            this.tabId = this.$route.params.id;
        },
        watch: {
            // 监听子路由变化，取消股票的激活状态
            '$route'(to) {
                this.tabId = to.params.id;
                this.$store.commit('SET_FOUCS_GP', null);
            },
            '$store.state.hideFooterTime'() {
                this.tableHeight = window.innerHeight - (this.$store.state.hideFooter ? 76 : 401) + 'px';
            }
        },
        methods: {
            // 左侧菜单点击，跳转到子路由
            setThisTab(index) {
                if (index !== +this.tabId && this.lenSta[index]) {
                    this.$router.push({path: '/trade/' + index});
                }
            },
            // 每屏显示了多少条
            trLines() {
                return parseInt(this.tableHeight) / 40;
            }
        }
    }
</script>

<style lang="scss">
    @import "TradePage";
</style>
